export const uk = {
    'create-group-error': 'Ошибка при создании группы',
    'geo-empty-regions': 'Выберите регионы показа',
    'warning-about-changes': 'Изменения не будут сохранены, продолжить?',
    'warning-about-changes-internal': 'У вас есть несохранённые группы. Выйти без сохранения изменений?',
    'warning-about-empty-retargeting-conditions':
        'Вы сохраняете группу, которая будет таргетирована на всех пользователей в выбранном регионе. Продолжить?'
};
